// extracted by mini-css-extract-plugin
export var dropdown = "_f2-0";
export var imagePlaceholder = "_f2-2";
export var imageWrapper = "_f2-3";
export var productImage = "_f2-1";
export var truncateContainer = "_f2-4";
export var truncateText = "_f2-5";